import React, { useEffect, useState } from 'react';
import Modal from '../Modal/Modal';
import { useUISettings } from '../Context/UISettingsProvider';

const OrientationOverlay: React.FC = () => {
  const [isLandscape, setIsLandscape] = useState(false);
  const { showHUD, isMobileDevice, isNativeApp, isTablet } = useUISettings();

  useEffect(() => {
    const checkOrientation = () => {
      setIsLandscape(window.innerWidth > window.innerHeight);
    };

    window.addEventListener('resize', checkOrientation);
    checkOrientation(); // Check initial orientation

    return () => {
      window.removeEventListener('resize', checkOrientation);
    };
  }, []);

  if (isNativeApp || !isMobileDevice || isTablet || !showHUD || !isLandscape) {
    return null;
  }

  return (
    <Modal isOpen={true} maxWidthClass="h-1/2 max-w-[66%]">
      <div className="flex items-center justify-center h-full">
        <div className="text-3xl font-semibold text-center text-blue-500">
          Please rotate your device to portrait
        </div>
      </div>
    </Modal>
  );
};
export default OrientationOverlay;
